import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  IExam,
  SaqCandidateQuestionModel
} from 'src/app/interface/dto';
import { ExamScheduleService } from 'src/app/services/exam-schedule-service';
import { ExamService } from 'src/app/services/exam-service.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';


@Component({
  selector: 'app-view-script',
  templateUrl: './exam-question-analysis.component.html',
  styleUrls: ['./exam-question-analysis.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ExamQuestionAnalysisComponent implements OnInit {
  examination: IExam;
  candidatesQuestionsData: SaqCandidateQuestionModel[] = [];
  selectedCandidateQuestion: SaqCandidateQuestionModel = null;
  adjustmentData = { score: 0, reason: '' };
  sanitizedHtml: SafeHtml;

  constructor(
    private snackBar: SnackbarService,
    private examService: ExamService,
    private sanitizer: DomSanitizer,
  ) {}

  async ngOnInit() {
    const selectedExamID = this.examService.selectedExamIds?.[0];
    this.examination = this.examService.selectedExams?.[0];

    if (!selectedExamID) {
      console.warn('Missing required IDs:', { selectedExamID });
      return;
    }

    try {
      const rawResponse = await this.examService.getQuestionAnalysisHtmlContent(selectedExamID);
      const response = rawResponse as { file: string; fileName: string };

      if (!response?.file) {
        this.snackBar.error('There are no schedules for this exam.');
        return;
      }

      const htmlString = atob(response.file);
      const cleanedhtmlString = htmlString.replace(/<math-field/g, "<math-field read-only")

      this.sanitizedHtml = this.sanitizer.bypassSecurityTrustHtml(cleanedhtmlString);
    } catch (error) {
      console.error('Error loading exam script content:', error);
      this.snackBar.error('Error loading exam script content');
    }
    document.getElementById('printPageBtn').addEventListener('click', () => {
        window.print();
    });
  }
  // async ngAfterViewInit(){
  //   // const container = document.getElementById("questionscontainer")
  //   const mathFields = document.querySelectorAll('math-field');
  //   console.log(mathFields)
  //   mathFields.forEach((field) => {
  //       field.setAttribute('read-only', '');
  //       field.setAttribute('virtual-keyboard-mode', 'off');
  //   });
  // }

}